// extracted by mini-css-extract-plugin
export default {"wrapper":"Banner_wrapper__Wd1rK","banner":"Banner_banner__UoU-z"};